/** Sabit katalog: yetkisi olmayan platform da listede görünmeli. */
export const PERMISSION_PLATFORMS = [
  "Emergency",
  "SECAI",
  "Secnet",
  "Secupoly",
  "SecuritasEmbassy",
  "SECWP",
  "SGK",
  "Smart",
  "Smartv3",
  "SMBOX",
  "SRA",
  "Tudep",
  "UDK",
];

export const OTHER_PLATFORM = "Diğer";

const BY_LOWER = new Map(
  PERMISSION_PLATFORMS.map((platform) => [platform.toLowerCase(), platform])
);

export function platformOf(permission: string): string {
  const prefix = (permission.split("_")[0] || "").toLowerCase();
  return BY_LOWER.get(prefix) || OTHER_PLATFORM;
}

export const ALL_PLATFORMS = [...PERMISSION_PLATFORMS, OTHER_PLATFORM];
